import { render, staticRenderFns } from "./Cadastros.vue?vue&type=template&id=a1b52c16&"
import script from "./Cadastros.vue?vue&type=script&lang=js&"
export * from "./Cadastros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports